import { BaseModel } from "../Generics/BaseModel"
import { OrderEntity } from "../Order/OrderEntity"
import { CourierEntity } from "../Courier/CourierEntity"
import { EDeliveryStatusType } from "../../Enum/EDeliveryStatusType"

export class DeliveryEntity extends BaseModel {
  id: number

  orderId: number

  order?: OrderEntity

  courierEntityId?: string

  courierEntity?: CourierEntity

  userId: string

  pickupLatitude: number

  pickupLongitude: number

  dropoffLatitude: number

  dropoffLongitude: number

  estimatedDistanceKm?: number

  status: EDeliveryStatusType

  offerExpiresDateTime?: Date

  createdDatetime: Date

  updatedDatetime: Date

  constructor(data: Partial<DeliveryEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.orderId = data.orderId ?? -1

    this.order = data.order ? new OrderEntity(data.order) : undefined

    this.courierEntityId = data.courierEntityId

    this.courierEntity = data.courierEntity ? new CourierEntity(data.courierEntity) : undefined

    this.userId = data.userId ?? ""

    this.pickupLatitude = data.pickupLatitude ?? 0

    this.pickupLongitude = data.pickupLongitude ?? 0

    this.dropoffLatitude = data.dropoffLatitude ?? 0

    this.dropoffLongitude = data.dropoffLongitude ?? 0

    this.estimatedDistanceKm = data.estimatedDistanceKm

    this.status = data.status ?? EDeliveryStatusType.Pending

    this.offerExpiresDateTime = data.offerExpiresDateTime ? new Date(data.offerExpiresDateTime) : undefined

    this.createdDatetime = data.createdDatetime ? new Date(data.createdDatetime) : new Date()

    this.updatedDatetime = data.updatedDatetime ? new Date(data.updatedDatetime) : new Date()
  }

  IsFindingCourier() {
    return this.status === EDeliveryStatusType.Pending || this.status === EDeliveryStatusType.Offered
  }
}
